/**
 * Returns element by selector
 */
var $ = function (selector, root) {
    if (root === void 0) { root = document; }
    return root.querySelector(selector);
};
/**
 * Returns array of elements by selector
 */
var $$ = function (selectors, root) {
    if (root === void 0) { root = document; }
    return Array.from(root.querySelectorAll(selectors));
};
/**
 * Adds multiple attributes at once.
 */
var setAttributes = function (element, options) {
    Object.keys(options).forEach(function (attr) {
        element.setAttribute(attr, options[attr]);
    });
};
/**
 * Shorter version for native insertBefore method.
 */
var insertNodeBefore = function (newElement, reference) {
    var _a;
    (_a = reference.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(newElement, reference);
};
/**
 * Workaround for missing insertAfter method.
 */
var insertNodeAfter = function (newElement, reference) {
    var _a;
    (_a = reference.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(newElement, reference.nextSibling);
};
/**
 * Find the closest element by selector.
 */
var closest = function (element, selector, checkSelf) {
    if (checkSelf === void 0) { checkSelf = true; }
    var parent = checkSelf ? element : element.parentNode;
    while (parent && parent instanceof HTMLElement) {
        if (parent.matches(selector))
            return parent;
        parent = parent.parentNode;
    }
    return undefined;
};
/**
 * Get an elements top position relative to the viewport.
 */
var getTopPosition = function (node) {
    var rect = node.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
};
/**
 * Get next Sibling who matches the selector (equivalent to jQuery´s next())
 */
var getNextSibling = function (target, selector) {
    if (selector === void 0) { selector = '*'; }
    // Get the next sibling element
    var sibling = target.nextElementSibling;
    // If the sibling matches our selector, return it else, jump to the next sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        else if (!sibling || sibling !== null) {
            return;
        }
        sibling = target.nextElementSibling;
    }
};
/**
 * Get previous Sibling who matches the selector (equivalent to jQuery´s prev())
 */
var getPrevSibling = function (target, selector) {
    if (selector === void 0) { selector = '*'; }
    // Get the previous sibling element
    var sibling = target.previousElementSibling;
    // If the sibling matches our selector, return it else, jump to the previous sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        else if (!sibling || sibling !== null) {
            return;
        }
        sibling = target.previousElementSibling;
    }
};
/**
 * Help preventing firing multiple times when multiple prefixed events are applied.
 * i.e. el.addEventListener('webkitTransitionEnd transitionend')
 *
 * Usage:
 * const TRANSITIONEND = whichTransitionEvent();
 */
var whichTransitionEvent = function () {
    if (typeof document === 'undefined') {
        return;
    }
    var el = document.createElement('fakeelement');
    var transitions = {
        transition: 'transitionend',
        OTransition: 'oTransitionEnd',
        MozTransition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd',
    };
    for (var t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }
};
/**
 * Help preventing firing multiple times when multiple prefixed events are applied.
 * i.e. el.addEventListener('webkitAnimationEnd animationend')
 *
 * Usage:
 * const ANIMATIONEND = whichAnimationEvent();
 */
var whichAnimationEvent = function () {
    if (typeof document === 'undefined') {
        return;
    }
    var el = document.createElement('fakeelement');
    var animations = {
        animation: 'animationend',
        OAnimation: 'oAnimationEnd',
        MozAnimation: 'animationend',
        WebkitAnimation: 'webkitAnimationEnd',
    };
    for (var t in animations) {
        if (el.style[t] !== undefined) {
            return animations[t];
        }
    }
};
/**
 * Insert HTML string into DOM.
 *
 * Possible values for position in comparison to jQuery:
 * 'beforebegin' - $().before
 * 'afterbegin'  - $().prepend
 * 'beforeend'   - $().append
 * 'afterend'    - $().insertAfter
 */
var insertHTML = function (node, position, htmlString) {
    node.insertAdjacentHTML(position, htmlString);
};

export { $, $$, closest, getNextSibling, getPrevSibling, getTopPosition, insertHTML, insertNodeAfter, insertNodeBefore, setAttributes, whichAnimationEvent, whichTransitionEvent };
